<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JP5RbT/tc-custom/buylink_9781501125393_cover.jpg?1716662162757?1730493402971" alt="This image is the cover for the book Dr. Haggard's Disease"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dr. Haggard's Disease
      </h1>
      <p class="bookDescription body article font2">
        <p>“A stormy tale of obsession…this is a haunting portrayal of a man broken by passion” (<i>Library Journal</i>).<br/><br/>Dr. Edward Haggard is a lonely, pain-racked romantic, standing at the window of his house on the edge of a cliff, watching as the clouds of war draw near, and reflecting on the nature of love, death, medicine, war—but most of all on the wife of the senior pathologist, and the few brief months of bliss they shared.<br/><br/>Shortly after the outbreak of World War II, a fighter pilot appears in Dr. Haggard’s surgery, reawakening memories of the single grand passion of Haggard’s life. For this young man is the son of the woman Haggard loved, and as the doctor becomes more and more intrigued by the bizarre changes occurring in his new patient’s body, his old passion gives way to a fresh one, a passion altogether odder, and darker, than the first.<br/><br/>In true gothic fashion, Patrick McGrath brings to his narration of a doomed love affair and bizarre aftermath an acute erotic intensity, portraying a man whose disease is passion—disease that can exalt a man, but can also destroy him.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick McGrath
      </h2>
      
      <p class="authorDescription body article">Patrick McGrath&#160;is the author of several modern gothic novels, including&#160;<I>Asylum</I>&#160;and&#160;<I>Spider</I>, and two collections of stories. He lives in New York, where he is on the writing faculties of the New School and Princeton University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon & Schuster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1352734c